import { inventoryApi } from '../api/inventoryApi'

export const getStock = async () => {
  try {
    const {
      data: { stock },
    } = await inventoryApi.getStockItems()
    return stock
  } catch (error) {
    console.error(`Error fetching stock: `, error)
    throw error
  }
}
